import updateSiteProperty from '../base-saving-actions/update-site-property';

const updateSiteProperties = (properties) =>
  properties.map(({ name, value }) => updateSiteProperty(name, value));

export default updateSiteProperties;
